
const routePath = {
    // Unprotected routes
    login: "/login-page",
    resetPassword: "/reset-password",
    register: "/register",
  
    // Common protected routes for all authenticated users
    home: "/",
    notActiveUser: "/not-active",
    empPositionManagement: "/position-management",
    profile: "/profile-page",
    editProfile:(id)=>`/edit-profile-page/${id}`,
    support: "/support-page",
    newDeposit: (itemId) => `/new-deposit/${itemId}`,
    displayDeposit: (depositId) => `/display-deposit/${depositId}`,
  
    // Employee-specific evaluation routes
    employeeEvaluation: "/evaluation",
    myEvaluation: "/evaluation/my-evaluation",
    subordinateEvaluation: "/evaluation/subordinate-evaluation",
    createNewEvaluation: (hierId) =>`/evaluation/subordinate-evaluation/newEvaluation/${hierId}`,
    updateEvaluation:(hierId)=> `/evaluation/subordinate-evaluation/updateEvaluation/${hierId}`,
    archiveEvaluations: "/evaluation/previous-evaluation",
    detailsEvaluation: (empEvalId)=> `/previous-evaluation/details-evaluation/${empEvalId}`,
    empRequests:(empId)=>`/employee/requests/${empId}`,
    annualEvaluation: "/evaluation/annual-evaluation",

    // Students routes (add routes here when defined)
  };
  
  export { routePath };
  